import { useTranslation } from 'react-i18next';
import logoUrl from '@Assets/logos/lili-logo-blue.svg';

import { DnbCarousel } from './DnbCarousel';
import { DnbCarouselMobile } from './DnbCarouselMobile';
import { DnbIntroCopy, DnbIntroCta } from './DnbIntroContent';
import { DnbLegalText } from './DnbLegalText';
import { useDnbEmbeddedIntroLogic } from './useDnbEmbeddedIntroLogic';

export const DnbEmbeddedIntro = () => {
  const { t } = useTranslation();
  const { handleGetStarted } = useDnbEmbeddedIntroLogic();

  return (
    <div
      id='dnb-embedded-intro-page'
      className='flex flex-col w-full min-h-dvh tab-landscape:h-dvh overflow-y-auto fade-in'>
      {/* Mobile layout */}
      <div className='flex h-dvh flex-col overflow-y-auto tablet:hidden'>
        <div className='flex shrink-0 justify-center px-[16px] pt-[16px]'>
          <img src={logoUrl} alt={t('pages.dnbEmbeddedIntro.logoAlt')} className='w-[53px]' />
        </div>
        <div className='shrink-0 pt-[16px]'>
          <DnbCarouselMobile />
        </div>
        <DnbIntroCopy variant='mobile' className='px-[16px] pt-[24px]' />
        <div className='px-[16px] pt-[24px] pb-[24px]'>
          <DnbLegalText />
        </div>
        <DnbIntroCta
          variant='mobile'
          buttonId='dnb-embedded-intro-get-started-mobile'
          onGetStarted={handleGetStarted}
          className='sticky bottom-0 border-t border-outline-primary-bw-03 bg-surface-primary-bw-00 px-[16px] pt-[16px] pb-[24px]'
        />
      </div>

      {/* Tablet layout */}
      <div className='hidden tablet:flex tab-landscape:hidden flex-col w-full h-dvh overflow-y-auto bg-surface-primary-bw-00'>
        <div className='grid grid-cols-2 gap-[40px] w-full p-[40px]'>
          <div className='flex flex-col min-w-0'>
            <img
              src={logoUrl}
              alt={t('pages.dnbEmbeddedIntro.logoAlt')}
              className='w-[77px] mb-[32px]'
            />
            <div className='flex flex-col gap-[72px]'>
              <DnbIntroCopy variant='desktop' />
              <DnbIntroCta
                variant='tablet'
                buttonId='dnb-embedded-intro-get-started-tablet'
                onGetStarted={handleGetStarted}
              />
            </div>
          </div>
          <div className='flex w-full min-w-0'>
            <DnbCarousel variant='tablet' />
          </div>
        </div>
        <div className='px-[16px] pt-[24px] pb-[16px]'>
          <DnbLegalText />
        </div>
      </div>

      {/* Desktop layout */}
      <div className='hidden tab-landscape:flex flex-col flex-1 mx-auto w-full max-w-[1440px]'>
        <div className='grid grid-cols-[0.75fr_1fr] grid-rows-1 gap-[24px] flex-1 py-[40px]'>
          <div className='flex justify-center w-full min-w-0 bg-surface-primary-bw-00 px-[40px] pc-md:px-[96px]'>
            <div className='flex flex-col justify-center w-full max-w-[420px]'>
              <img
                src={logoUrl}
                alt={t('pages.dnbEmbeddedIntro.logoAlt')}
                className='w-[77px] mb-[72px]'
              />
              <div className='flex flex-col gap-[72px]'>
                <DnbIntroCopy variant='desktop' />
                <DnbIntroCta
                  variant='desktop'
                  buttonId='dnb-embedded-intro-get-started-desktop'
                  onGetStarted={handleGetStarted}
                />
              </div>
            </div>
          </div>
          <div className='flex items-center justify-end w-full min-w-0 p-[16px] bg-surface-primary-bw-00'>
            <DnbCarousel />
          </div>
        </div>
        <div className='px-[16px] py-[16px]'>
          <DnbLegalText className='text-text-main-secondary' />
        </div>
      </div>
    </div>
  );
};

export default DnbEmbeddedIntro;
